// Cave84 — Purchase Lots service
// A PurchaseLot groups bottles acquired together in a single auction transaction.
// Created by the supplier invoice import flow (pages/InvoiceImportPage.tsx).

import { addDoc, collection, Timestamp } from 'firebase/firestore';
import type { PurchaseLot, PurchaseSource, Currency } from '@cave84/shared-types';
import { db } from './firebase';

const COLLECTION = 'purchase_lots';

export interface PurchaseLotCreateInput {
  source: PurchaseSource;
  source_reference: string;   // invoice number, e.g. "55640"
  purchase_date: Date;
  total_cost_landed: number;  // sum of all cost_landed values in the lot
  currency: Currency;
  notes?: string;
  bottles: string[];          // bottle IDs — populated after bottles are created
}

export async function createPurchaseLot(input: PurchaseLotCreateInput): Promise<string> {
  const payload: Omit<PurchaseLot, 'id'> = {
    source: input.source,
    source_reference: input.source_reference,
    // The invoice date, not the moment of import.
    purchase_date: Timestamp.fromDate(input.purchase_date),
    total_cost_landed: input.total_cost_landed,
    currency: input.currency,
    notes: input.notes,
    bottles: input.bottles,
  };
  const ref = await addDoc(collection(db, COLLECTION), payload);
  return ref.id;
}
